module.exports = __webpack_public_path__ + "../resources/images/emptyDeletedItemsFolder-123a0f6a1a8a6ac45b6fad777ecf7506.svg";